<!-- Link to PDF -->
<div class="centerLinkInDiv">
	<a class="pdrButton" href="/assets/community_guidelines.pdf">Get PDF</a>
</div>

<div class="pdfContainer">
    <embed class="pdfViewer" src="/assets/community_guidelines.pdf">
</div>
